import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { noop } from 'lodash';
import moment from 'moment';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { getParticularPreferenceSettings } from '../../../../common/selectors/preference';
import './DateTimeField.css';
import Message from './ValidationMessage';
import { getLocalDatetime } from '../../../../utils/local_date';

class DateField extends Component {
  constructor() {
    super();

    this.handleOnChange = this.handleOnChange.bind(this);
  }

  _formatDate(date) {
    if (!date || !moment(date).isValid()) return null;
    return new Date(date);
  }

  handleOnChange(value) {
    const { change, formId, input, onDateChange, noTimezone } = this.props;
    const parsedValue = noTimezone ? value && getLocalDatetime(value) : value && value.toISOString();

    if (onDateChange) {
      onDateChange(parsedValue);
      return;
    }

    const { name } = input;
    change(formId, name, parsedValue);
  }

  render() {
    const {
      intl,
      translation,
      label,
      input,
      min,
      max,
      className,
      required,
      disabled,
      time,
      readOnly,
      placeholder,
      dateFormat,
      timeFormat,
      dateTimeFormat,
      meta,
    } = this.props;

    const { touched, error, warning } = meta || {};
    const { value } = input || {};
    const showError = touched && error ? 'error' : '';

    let newLabel = label;
    const minDate = this._formatDate(min) || undefined;
    const maxDate = this._formatDate(max) || undefined;
    const valDate = this._formatDate(value);

    if (minDate && !time) minDate.setHours(0, 0, 0, 0);
    if (maxDate && !time) maxDate.setHours(23, 59, 59, 999);
    if (valDate && !time) valDate.setHours(0, 0, 0, 0);

    const dates = {
      min: minDate,
      max: maxDate,
      value: valDate,
    };

    if (intl && translation) {
      const labelObj = translation.label;
      if (labelObj && labelObj.message) {
        newLabel = intl.formatMessage(labelObj.message, labelObj.params);
      }
    }

    return (
      <div
        className={`field ${showError} ${className} ${
          disabled ? 'disabled' : ''
        }`}
      >
        {newLabel && (
          <label>
            {`${newLabel} `}
            {required ? <span style={{ color: 'red' }}>*</span> : null}
          </label>
        )}

        <DateTimePicker
          {...input}
          onChange={this.handleOnChange}
          onBlur={noop}
          time={time ? true : false}
          readOnly={readOnly}
          placeholder={placeholder}
          format={time ? dateTimeFormat : dateFormat}
          timeFormat={timeFormat}
          {...dates}
        />

        <div>
          <Message show={touched} message={error} />
          <Message show={touched} message={warning} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const dateFormat = (
    getParticularPreferenceSettings(state, 'date_format', ['value']) || {}
  ).value;

  const timeFormat = (
    getParticularPreferenceSettings(state, 'time_format', ['value']) || {}
  ).value;

  const dateTimeFormat = (
    getParticularPreferenceSettings(state, 'date_time_format', ['value']) || {}
  ).value;

  return {
    dateTimeFormat,
    dateFormat,
    timeFormat,
  };
};

export default connect(mapStateToProps, { change })(DateField);
